import HotelRoom from './hotel-room-component';
import HotelRoomDetailsService from './hotel-room-details/hotel-room-details-service';
import HotelRoomSuperRoomModule from './hotel-room-super-room/hotel-room-super-room-module';

const MODULE_NAME = 'app.hotels.hotel-room';
const module = angular
    .module(MODULE_NAME, [
        HotelRoomSuperRoomModule,
    ])
    .directive('ktHotelRoom', HotelRoom)
    .service('hotelRoomDetailsService', HotelRoomDetailsService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-module.js